export const INVOICE = 'Invoice';
export const CARD = 'Credit Card';
